var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"overflow-hidden"},[_c('ProjectMenu',{staticClass:"max-w-[300px] min-w-[300px] overflow-y-auto py-7 px-3 border-r border-[#dfe4ef] menu-container",attrs:{"selectedTabIndex":0}}),_c('router-view',{key:_vm.routeNameAndParams,staticClass:"width-100 px-[3%]"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }